import React, { useState, useEffect } from 'react';
import { Button } from '@bepro-travel/fe.ui';
import '../styles/cookieAccept.scss';
import {
  initializeCookiePreferences,
  removeAllCookies,
  disableTracking,
  cleanupCookieObserver,
  getCookiePreference,
} from '../utils/cookieManager.ts';

declare global {
  interface Window {
    ga?: {
      getAll: () => Array<{
        get: (key: string) => string;
      }>;
    };
  }
}

const CookieAccept: React.FC = () => {
  const [isVisible, setIsVisible] = useState(true);
  const [showRejectionMessage, setShowRejectionMessage] = useState(false);

  useEffect(() => {
    initializeCookiePreferences();

    const preference = getCookiePreference();
    if (preference) {
      setIsVisible(false);
    }

    // Cleanup when component unmounts
    return () => {
      cleanupCookieObserver();
    };
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    cleanupCookieObserver(); // Clean up any existing cookie observer
    setIsVisible(false);
  };

  const rejectCookies = () => {
    localStorage.setItem('cookiesAccepted', 'false');

    removeAllCookies();
    disableTracking();

    initializeCookiePreferences();

    setShowRejectionMessage(true);

    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };

  if (!isVisible) return null;

  return (
    <div className="cookie-banner rtl">
      <div className="cookie-content">
        {!showRejectionMessage ? (
          <>
            <h2 className="title-blue">אנו משתמשים בעוגיות</h2>
            <p className="mb-20">
              אנו משתמשים בעוגיות ובטכנולוגיות מעקב אחרות כדי לשפר את חווית
              הגלישה שלך באתר האינטרנט שלנו, כדי להציג לך תוכן מותאם אישית
              ומודעות ממוקדות, לנתח את התנועה באתר שלנו ולהבין מהיכן מגיעים
              המבקרים שלנו.
            </p>
            <div className="button-container">
              <Button
                className="btn btn-default"
                title="אני מסרב/ת"
                onClick={rejectCookies}
              />
              <Button
                className="btn btn-primary"
                title="אני מסכים/ה"
                onClick={handleAccept}
              />
            </div>
          </>
        ) : (
          <div className="rejection-message">
            <h2 className="title-blue">הודעה חשובה</h2>
            <p className="mb-20">
              בחרת לדחות את השימוש בעוגיות. חלק מהתכונות באתר עלולות לא לעבוד
              כראוי. אם תרצה/י לשנות את בחירתך בעתיד, תוכל/י לעשות זאת דרך
              הגדרות האתר.
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default CookieAccept;
